module.exports = __webpack_public_path__ + "img/coin_9.76af90df.png";